import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder-remove",
  "use": "icon-folder-remove-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"folderRemoveIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-folder-remove\"> <title id=\"icon-folder-remove_folderRemoveIconTitle\">Remove from folder</title> <path d=\"M3 5H9L10 7H21V19H3V5Z\" /> <path d=\"M15 13H9\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol